import { AppAction } from '../App';


export async function hGetGroups(dispatchState: React.Dispatch<AppAction>, apiToken: string, setErrorMessage: React.Dispatch<React.SetStateAction<string>>) {
    const url = `https://api.hypothes.is/api/groups`;
    try {
        const response = await fetch(url, {
            headers: {
                "Authorization": `Bearer ${apiToken}`,
                // 'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        const data = await response.json();
        dispatchState({ hGroups: data });
        if (data.filter((g: any) => !g.public).length === 0) {
            setErrorMessage("No Private Groups Found. You may want to check your API token.");
        }
    } catch (e) {
        setErrorMessage("error:" + (e as Error).message);
    }
}
